import Util from '../../../../shared/util/util';
import SaveReport from '../../../../../mutations/ts/reporting/update_saved_report_mutation';
import {createToast} from '../../../../shared/components/toasts/another-toast/toaster';
import {IntlShape} from 'react-intl';
import {
	UpdateSavedReportInput as SaveReportInput,
	updateSavedReportMutationResponse as SaveReportResponse,
} from '../../../../../mutations/ts/reporting/__generated__/updateSavedReportMutation.graphql';
import {MODAL_TYPE, showModal} from '../../../../shared/components/modals/generic_modal_conductor';

export const saveReportMutation = (
	report: SaveReportInput,
	intl: IntlShape,
	callback?: (res: SaveReportResponse) => void
): void => {
	const onSuccess = (res: SaveReportResponse) => {
		createToast({
			duration: 5000,
			message: intl.formatMessage({id: 'common.action.saved'}, {entity: report.name}),
		});
		callback && callback(res);
	};
	Util.CommitMutation(SaveReport, report, onSuccess);
};

export const saveReport = (report: SaveReportInput, intl: IntlShape, callback: (res: SaveReportResponse) => void): void => {
	showModal({
		report: report,
		type: MODAL_TYPE.SAVE_REPORT_MODAL,
		saveReport: (saveReport: SaveReportInput, closeModal: () => void) => {
			const _callback = (res: SaveReportResponse) => {
				closeModal();
				callback && callback(res);
			};
			saveReportMutation(saveReport, intl, _callback);
		},
	});
};
